import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import masterAgentService from '../../services/master-agent-request';
import TableMasterAgent from 'components/TableMasterAgent';
import { useCompany, useUser } from 'models';

function Contracts() {  
  const user = useUser()
  const { company } = useCompany();

  const [filters, setFilters] = useState(!company ? {} : { company: company.document })
  const [data, setData] = useState([])
  const [columns, setColumns] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [filtersList, setFiltersList] = useState({   
    // 'Busca' : {
    //   width: 2,
    //   type: 'input',
    //   comparator: 'like',
    //   columns: [
    //     "Number",
    //     "Parceiro",
    //     //"Cliente Final"
    //   ]
    // },
    'Cliente Final': {
      width: 2,
      type: 'input',      
      comparator: 'like',
    },
    'Vencimento Contrato': {
      width: 2,
      comparator: 'like',
      type: 'select',
      options: {}
    },
    'Periodo': {
      width: 2,
      ref: 'Data de Assinatura do Contrato',
      type: 'date',
      comparator: 'between',
      data: {
        from: { label: 'Periodo Inicial', value: null },
        to: { label: 'Periodo Final', value: null }
      }
    }
  }); 
  useEffect(() => {
    const get = async () => {
      setIsLoading(true)
      const response = await masterAgentService.getAllContracts(filters)
      const { collection, columns } = response.data
      for (let item of collection) {
        const year = new Date(item['Vencimento Contrato']).getFullYear()
        if (!isNaN(year)) {          
          let aux = filtersList
          aux['Vencimento Contrato'].options[year] = year
          setFiltersList(aux)
        }
      }
      setColumns(columns)
      setData(collection)
      setIsLoading(false)
    }

    get()
  }, []);
  
  return (
    <Row>
      <Col md="12" className="mt-3">
        <TableMasterAgent
          setFiltersList={setFiltersList}
          isLoading={isLoading}
          collection={data}
          columns={columns}
          filtersList={filtersList}
          btnAddProps={{
            url: '/master-agent/new-order',
            label: 'Novo Pedido '
          }}
          fileExportName={'MA-Meus Contratos'}
        />
      </Col>
    </Row>
  );
}

export default Contracts;
